var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMediumProduct(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1 2H3.9C2.95 2 2 2.855 2 3.9V6.7595C2 7.4435 2.4085 8.0325 2.95 8.365V19.1C2.95 20.145 3.995 21 4.85 21H18.15C19.005 21 20.05 20.145 20.05 19.1V8.365C20.5915 8.0325 21 7.4435 21 6.7595V3.9C21 2.855 20.05 2 19.1 2ZM18.15 19.1H4.85V8.65H18.15V19.1ZM19.1 6.75H3.9V3.9H19.1V6.75Z",
    className: "fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6 10C8.72 10 8 10.72 8 11.6V18H9.6V11.6H11.2V17.2H12.8V11.6H14.4V18H16V11.6C16 10.72 15.288 10 14.4 10H9.6Z",
    className: "fill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumProduct);
export default __webpack_public_path__ + "static/media/medium-product.51d8dc89dcbade33bda6e2d4bcee32f6.svg";
export { ForwardRef as ReactComponent };